import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTired = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	viewBox: "0 200 600 450",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("style", { children: "\n            .st0 {\n            fill: none;\n            }\n\n            .st1 {\n            fill: #00b6e0;\n            }\n\n            .st2 {\n            fill: #0075c7;\n            }\n\n            .st3 {\n            fill: #020206;\n            }\n\n            .st4 {\n            fill: #003343;\n            }\n\n            .st5 {\n            mix-blend-mode: multiply;\n            opacity: .17;\n            }\n\n            .st6 {\n            fill: #73ccf4;\n            }\n\n            .st7 {\n            fill: #f48d2e;\n            }\n\n            .st8 {\n            isolation: isolate;\n            }\n\n            .st9 {\n            fill: #fff;\n            }\n\n            .st10 {\n            fill: #ffbe4f;\n            }\n\n            .st11 {\n            opacity: .32;\n            }\n\n            .st12 {\n            fill: #bbe5ff;\n            }\n\n            .st13 {\n            clip-path: url(#clippath);\n            }\n        " }), /* @__PURE__ */ _jsx("clipPath", {
			id: "clippath",
			children: /* @__PURE__ */ _jsx("ellipse", {
				className: "st0",
				cx: 100.4337,
				cy: 477.3421,
				rx: 45.889,
				ry: 26.7456,
				transform: "translate(-383.4995 538.588) rotate(-85.3311)"
			})
		})] }),
		/* @__PURE__ */ _jsx("g", {
			className: "st8",
			children: /* @__PURE__ */ _jsx("g", {
				id: "Layer_1",
				children: /* @__PURE__ */ _jsxs("g", { children: [
					/* @__PURE__ */ _jsxs("g", { children: [
						/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsxs("g", { children: [
							/* @__PURE__ */ _jsx("path", {
								className: "st6",
								d: "M484.914,436.5262l-.1519.2387c.8896,5.4676,1.6707,11.0438,2.2999,16.5982.1736,1.4537.3255,2.9074.4556,4.3611.716,17.8132-26.2968,76.9593-58.8206,74.0085l-.0868.8896c7.1166,7.8326,12.5192,16.3812,16.4897,23.8884,6.227,11.7381,8.8958,20.9376,8.8958,20.9376h-107.921c-17.6397,0-32.8493-3.6451-46.4316-14.038-.3038-.2387-.6075-.499-.9113-.7377-9.9589-8.6137-4.7083-18.0736-1.2584-33.0663,3.5583-15.4483-13.0616-32.3719-55.5227-32.5455-42.4394-.1953-77.48,13.8427-93.4056,12.3456-2.4084-.217-5.7714-.8679-9.8504-1.7792-22.2394-4.9469-65.5033-17.4878-86.4843-9.5033,2.7121-2.5819,4.7733-3.9272,4.7733-3.9272,0,0-12.5409-43.394,14.4719-111.8698,26.9911-68.4541,112.8245-80.995,134.0442-80.0403,4.079.1953,9.5033.6726,15.8171,1.7141,38.0132-26.2751,87.5041-41.1158,123.9117-39.3367,42.5045,2.0612,108.2247,31.8946,148.6896,105.2522,40.4432,73.3576,55.5227,89.153,34.2813,87.439-7.6807-.6292-15.47-3.5366-22.2828-6.9864l-.3255.0434c-1.0415-6.9213-3.1461-12.389-6.3789-13.4738-3.2329-1.0632-6.0752.6943-8.2015,4.1007-2.9074-2.1263-5.4676-4.0356-6.0969-4.513Z"
							}),
							/* @__PURE__ */ _jsx("path", {
								className: "st7",
								d: "M491.0109,441.0392c2.1263-3.4064,4.9686-5.1639,8.2015-4.1007,3.2329,1.0849,5.3375,6.5525,6.3789,13.4738.9547,6.2487,1.0415,13.6908.3472,20.1999-1.4537,13.7776,15.8171,46.2797,12.888,61.4893-2.9291,15.2313-8.7873,20.2216-19.6141,18.7462-7.7675-1.0415-10.5664-7.0515-11.5428-10.3712-.1953-.6726-1.0849-.7377-1.3886-.1302-1.7358,3.6234-5.9667,10.6532-12.5192,10.74-4.0356.0651-5.2507-2.1697-7.8109-5.0554l-1.3452-.1302c9.1995-7.2034,15.2096-16.6633,19.549-30.0721,5.1205-15.7954,5.446-36.7764,3.363-58.1046-.1302-1.4537-.2821-2.9074-.4556-4.3611l.1302-.0217c.5424-4.8601,1.8876-9.2429,3.8187-12.3022Z"
							}),
							/* @__PURE__ */ _jsx("path", {
								className: "st12",
								d: "M487.5177,457.7242c2.0829,21.3282,1.7575,42.3092-3.363,58.1046-4.3394,13.4088-10.3495,22.8687-19.549,30.0721-5.3375,4.1875-11.7381,7.6157-19.5056,10.6098-3.9706-7.5072-9.3731-16.0558-16.4897-23.8884l.0868-.8896c32.5238,2.9508,59.5366-56.1953,58.8206-74.0085Z"
							}),
							/* @__PURE__ */ _jsx("path", {
								className: "st10",
								d: "M138.6948,507.6273c4.079.9113,7.4421,1.5622,9.8504,1.7792,15.9256,1.4971,50.9663-12.5409,93.4056-12.3456,42.4611.1736,59.081,17.0972,55.5227,32.5455-3.4498,14.9926-8.7005,24.4525,1.2584,33.0663-2.1914-1.7358-4.3394-3.6451-6.444-5.7497-13.4955,17.401-37.6009,19.2453-54.0039,19.2453s-104.1457,2.8857-131.1585,0c-26.9911-2.8857-38.2084-.0651-56.9764-25.0817-19.8311-26.4487-6.0535-45.2383,2.0612-52.9624,20.981-7.9845,64.2449,4.5564,86.4843,9.5033Z"
							})
						] }), /* @__PURE__ */ _jsxs("g", { children: [
							/* @__PURE__ */ _jsx("path", {
								className: "st1",
								d: "M427.0049,532.4607c-.4159,0-.8311-.1638-1.1406-.489-9.5878-10.0744-20.4204-16.9395-32.1967-20.4041-43.0598-12.6999-64.5688-8.4965-64.7808-8.4526-.8504.1761-1.6842-.3696-1.8613-1.2199-.1773-.8502.3662-1.6832,1.2163-1.8617.8927-.1877,22.3734-4.4457,66.3155,8.514,12.3127,3.6226,23.6138,10.7734,33.5878,21.2539.5994.6297.5747,1.6262-.0552,2.2255-.3047.2899-.695.4338-1.085.4338Z"
							}),
							/* @__PURE__ */ _jsx("path", {
								className: "st1",
								d: "M316.3947,367.5202c-.5318,0-1.0509-.2696-1.3472-.7576-26.5124-43.6847-69.2678-56.9383-92.394-60.9504-.8566-.1486-1.4307-.9634-1.282-1.82.1486-.8564.9624-1.4305,1.82-1.282,23.6532,4.1036,67.3887,17.6696,94.5476,62.419.4511.7432.2142,1.7114-.529,2.1626-.2553.1548-.537.2286-.8154.2286Z"
							}),
							/* @__PURE__ */ _jsx("path", {
								className: "st1",
								d: "M484.3481,435.8008c-.754,0-1.4203-.5434-1.5502-1.3117-4.5959-27.1399-12.1019-53.0942-17.1412-64.7055-.3461-.7974.0197-1.7246.8174-2.0707.797-.3463,1.7246.0197,2.0707.8174,5.115,11.7855,12.7196,38.0458,17.3572,65.4332.1453.8572-.432,1.6698-1.2892,1.8149-.0889.0151-.1773.0225-.2646.0225Z"
							})
						] })] }),
						/* @__PURE__ */ _jsxs("g", { children: [
							/* @__PURE__ */ _jsx("path", { d: "M122.9758,406.1237c-1.1693.0002-2.2991-.6317-2.8821-1.738-2.4047-4.5633-8.3084-10.2555-15.588-11.9702-5.287-1.2448-10.3107-.1917-14.9334,3.131-1.4596,1.0485-3.4932.7163-4.5423-.7432-1.0489-1.4596-.7161-3.4932.7432-4.5423,6.132-4.407,13.1247-5.8529,20.2248-4.1811,9.3116,2.1931,16.6813,9.2503,19.8543,15.2715.8379,1.5901.2282,3.5584-1.3621,4.3965-.4838.2549-1.0029.3758-1.5144.3758Z" }),
							/* @__PURE__ */ _jsx("path", { d: "M184.524,447.7955c-1.3498,0-2.6113-.8463-3.0764-2.1939-1.41-4.0856-.5264-9.1859,2.363-13.643,2.8257-4.3584,6.9098-7.1722,10.9249-7.5269,1.7898-.1558,3.3701,1.1651,3.5283,2.9556.158,1.7904-1.1651,3.3701-2.9556,3.5283-1.9743.1744-4.3435,1.9737-6.0358,4.584-1.7814,2.7476-2.4218,5.8049-1.6716,7.9786.5862,1.6991-.3158,3.5518-2.0149,4.1382-.3515.1212-.7098.1789-1.0619.1789Z" }),
							/* @__PURE__ */ _jsxs("g", { children: [
								/* @__PURE__ */ _jsx("path", {
									className: "st9",
									d: "M226.9085,427.7624c20.8587-1.6972,38.2044,18.4486,38.7381,44.9628.52,26.5439-15.961,49.4199-36.8197,51.1171-20.8793,1.7046-38.225-18.4411-38.7587-44.9554-.5131-26.5217,15.961-49.4199,36.8403-51.1245Z"
								}),
								/* @__PURE__ */ _jsx("path", {
									className: "st9",
									d: "M104.5715,431.6462c14.6894,1.5842,24.7549,23.3358,22.4484,48.5741-2.279,25.2531-16.0418,44.4091-30.7312,42.8249-14.6963-1.6064-24.7343-23.3432-22.4553-48.5963.9708-10.6512,3.9721-20.2047,8.2421-27.571-1.3662,2.6902-2.5061,5.6695-3.3922,8.8788-4.5267,16.4019-.3326,32.2363,9.3408,35.353,9.7008,3.1316,21.1967-7.6492,25.7234-24.0512,4.5473-16.4093.3532-32.2437-9.3202-35.3604-.1029-.0371-.2264-.0668-.3225-.0817.1578-.0074.3019.0149.4666.0298Z"
								}),
								/* @__PURE__ */ _jsx("path", {
									className: "st3",
									d: "M104.4274,431.698c9.6734,3.1167,13.8675,18.9511,9.3202,35.3604-4.5267,16.4019-16.0226,27.1827-25.7234,24.0512-9.6734-3.1167-13.8675-18.9511-9.3408-35.353.8861-3.2092,2.026-6.1886,3.3922-8.8788,5.7185-9.9379,13.7069-15.9242,22.0293-15.2614.0961.0149.2195.0446.3225.0817Z"
								})
							] }),
							/* @__PURE__ */ _jsx("path", { d: "M225.402,517.3827c-3.2444,0-6.4622-.6992-9.5195-2.114-6.8299-3.1609-18.6627-12.8623-21.174-42.3226-.0943-1.1077.7271-2.0821,1.8346-2.1765,1.1111-.0943,2.0823.7271,2.1765,1.8346,2.3383,27.4336,12.816,36.2172,18.8536,39.0112,6.4535,2.9863,13.8424,2.0737,20.2718-2.5061,7.3677-5.2475,14.6532-16.6795,13.0059-33.0278-.1116-1.1061.6948-2.093,1.8007-2.2044,1.1065-.1136,2.093.6948,2.2044,1.8007,1.5227,15.1119-4.1006,29.1785-14.6757,36.7104-4.646,3.3091-9.7432,4.9941-14.7784,4.9945Z" })
						] }),
						/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", { d: "M174.3752,514.6855c-.034.084-.0433.1629-.0773.2469l-.1383-.0484c-2.7068,2.1755-6.9345,3.0742-11.8757,3.3761-4.9903.3121-16.6652-4.4102-27.0177-8.0713l-.4446-.1648c-.0297-.0195-.084-.034-.1086-.0289l-.0051-.0246c-5.754-2.0191-11.0771-3.6911-14.5135-3.9308-9.634-.6791-19.5925-2.805-13.4671-4.4548,6.1253-1.6498,39.2523-8.8498,52.6243-8.5834,13.377.291,19.868,3.5179,17.8495,16.4819-.336,2.2247-1.3456,3.9214-2.8259,5.2021Z" }), /* @__PURE__ */ _jsx("path", { d: "M174.1596,514.884l.1383.0484c-2.2781,8.476-7.8249,12.8031-17.1315,12.467-9.4101-.3404-22.5275-11.9236-22.4533-17.4043.0246-.0051.0789.0094.1086.0289l.4446.1648c10.3524,3.6611,22.0273,8.3834,27.0177,8.0713,4.9411-.3019,9.1689-1.2006,11.8757-3.3761Z" })] }),
						/* @__PURE__ */ _jsxs("g", { children: [
							/* @__PURE__ */ _jsx("path", {
								className: "st2",
								d: "M139.1406,362.8997h-.0173l-60.0643-.2224c-1.2021-.0044-2.3306-.4768-3.1774-1.3299-.8469-.8532-1.3109-1.9852-1.3064-3.1874l.1213-32.7539c.0092-2.4812,2.0165-4.4662,4.5168-4.4838l60.0647.2226c1.2019.0042,2.3304.4766,3.1774,1.3299.8469.8532,1.3109,1.985,1.3064,3.1872l-.1213,32.7541c-.0042,1.2017-.4766,2.3304-1.3299,3.1772-.849.8429-1.9745,1.3064-3.17,1.3064ZM139.1402,358.3199h.0002-.0002ZM79.1967,325.5023l-.0416,32.675,59.9059.1425.1212-32.6748-59.9854-.1427Z"
							}),
							/* @__PURE__ */ _jsx("rect", {
								className: "st2",
								x: 157.3353,
								y: 323.8087,
								width: 4.58,
								height: 38.0255,
								transform: "translate(-186.4602 495.2404) rotate(-88.8014)"
							}),
							/* @__PURE__ */ _jsx("path", {
								className: "st2",
								d: "M139.1406,362.8997h-.0173l-60.0643-.2224c-1.2021-.0044-2.3306-.4768-3.1774-1.3299-.8469-.8532-1.3109-1.9852-1.3064-3.1874l.1213-32.7539c.0092-2.4812,2.0165-4.4662,4.5168-4.4838l60.0647.2226c1.2019.0042,2.3304.4766,3.1774,1.3299.8469.8532,1.3109,1.985,1.3064,3.1872l-.1213,32.7541c-.0042,1.2017-.4766,2.3304-1.3299,3.1772-.849.8429-1.9745,1.3064-3.17,1.3064ZM139.1402,358.3199h.0002-.0002ZM79.1967,325.5023l-.0416,32.675,59.9059.1425.1212-32.6748-59.9854-.1427Z"
							}),
							/* @__PURE__ */ _jsx("g", {
								className: "st11",
								children: /* @__PURE__ */ _jsx("rect", {
									className: "st9",
									x: 76.9256,
									y: 323.3235,
									width: 64.486,
									height: 37.1752,
									rx: 1.3542,
									ry: 1.3542,
									transform: "translate(1.2671 -.402) rotate(.2122)"
								})
							}),
							/* @__PURE__ */ _jsx("path", {
								className: "st2",
								d: "M239.1513,363.2701h-.0171l-60.0645-.2224c-2.4814-.0094-4.4927-2.0356-4.4838-4.5168l.1213-32.7543c.0092-2.4812,2.0598-4.4826,4.5168-4.4838l60.0649.2226c1.2019.0042,2.3304.4766,3.1774,1.3299.8469.8532,1.3107,1.985,1.3062,3.1872l-.1212,32.7541c-.0092,2.4758-2.0265,4.4836-4.5001,4.4836ZM239.1511,358.6903h.0002-.0002ZM179.2074,325.8727l-.0416,32.675,59.9061.1425.121-32.6748-59.9854-.1427Z"
							}),
							/* @__PURE__ */ _jsx("path", {
								className: "st2",
								d: "M239.1513,363.2701h-.0171l-60.0645-.2224c-2.4814-.0094-4.4927-2.0356-4.4838-4.5168l.1213-32.7543c.0092-2.4812,2.0598-4.4826,4.5168-4.4838l60.0649.2226c1.2019.0042,2.3304.4766,3.1774,1.3299.8469.8532,1.3107,1.985,1.3062,3.1872l-.1212,32.7541c-.0092,2.4758-2.0265,4.4836-4.5001,4.4836ZM239.1511,358.6903h.0002-.0002ZM179.2074,325.8727l-.0416,32.675,59.9061.1425.121-32.6748-59.9854-.1427Z"
							}),
							/* @__PURE__ */ _jsx("g", {
								className: "st11",
								children: /* @__PURE__ */ _jsx("rect", {
									className: "st9",
									x: 176.9364,
									y: 323.694,
									width: 64.486,
									height: 37.1752,
									rx: 1.3542,
									ry: 1.3542,
									transform: "translate(1.2691 -.7724) rotate(.2122)"
								})
							})
						] }),
						/* @__PURE__ */ _jsx("ellipse", {
							className: "st9",
							cx: 92.3022,
							cy: 444.8931,
							rx: 10.1109,
							ry: 4.9951,
							transform: "translate(-325.9345 267.3329) rotate(-55.2757)"
						})
					] }),
					/* @__PURE__ */ _jsx("g", {
						className: "st13",
						children: /* @__PURE__ */ _jsx("g", {
							className: "st5",
							children: /* @__PURE__ */ _jsx("path", {
								className: "st4",
								d: "M135.2781,484.8821s-11.8498-15.0277-37.7211-15.9169c-23.168-.7962-32.3643,14.0599-32.3643,14.0599,0,0,1.9725-56.316,36.2298-55.2974,37.1038,1.1032,33.8556,57.1544,33.8556,57.1544Z"
							})
						})
					}),
					/* @__PURE__ */ _jsx("rect", {
						className: "st2",
						x: 92.4813,
						y: 463.5699,
						width: 11.813,
						height: 11.813,
						transform: "translate(247.9197 13.704) rotate(30)"
					})
				] })
			})
		})
	]
});
const ForwardRef = forwardRef(SvgTired);
export default ForwardRef;
